import { CSRF_CONFIG, DEFAULT_METHOD, GET_METHOD, POST_METHOD } from './constants';
import axiosInstance from './interceptors';

const NOT_FOUND = 'method not found';

export default async function buildRequest({ fullPath, data = {}, options }) {
  options && (axiosInstance.options = options);
  const { method = DEFAULT_METHOD, headerConfig } = data;
  const HEADER_CONFIG = headerConfig;
  HEADER_CONFIG && delete data.headerConfig;
  let paramsObj = {};
  let config = { headers: HEADER_CONFIG };
  if (method.toUpperCase() === GET_METHOD) {
    const { params = {} } = data;
    paramsObj = { params, ...config };
  } else if (method.toUpperCase() === POST_METHOD) {
    const { body = {} } = data;
    paramsObj = body;
    const postConfig = { headers: { ...CSRF_CONFIG, ...HEADER_CONFIG } };
    config = postConfig;
  } else {
    throw NOT_FOUND;
  }
  return axiosInstance[method](fullPath, paramsObj, config);
}
